import Form from 'shared/components/Form'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;

  div {
    text-align: center;
  }
`

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`

export const ContainerIcon = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;

    transform: rotate(90deg);
  }
`

export const StyledForm = styled(Form)`
  padding: 0px;
`

export const ContainerContent = styled.div`
  display: flex;

  flex-direction: column;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & > input {
    max-width: 280px;
    margin: 21px 0px;
  }
`
